import React from 'react';
import { lazy } from 'react';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';

import Login from './components/Login';
import ProtectedPages from './ProtectedPages';

import { AUTH_TOKEN } from './Context';


function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    // "document.documentElement.scrollTo" is the magic for React Router Dom v6
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // Optional if you want to skip the scrolling animation
    });
  }, [pathname]);

  return null;
}


// JS code splitting
const DataGrid = lazy(() => import('./components/ExportDataGrid'));


function App() {
  const [authToken, setAuthToken] = useState();
  const [appUserName, setAppUserName] = useState();

  if(!authToken) {
    let savedToken = localStorage.getItem('authToken');
    let savedUserName = localStorage.getItem('username');
    if (savedToken) {
      setAuthToken(savedToken);
      setAppUserName(savedUserName);
    } else {
      return <Login setToken={setAuthToken} setAppUserName={setAppUserName}/>;
    }
  }
  
  let token = "Token " + authToken
  return(
    <AUTH_TOKEN.Provider value={token}>
      <ProtectedPages setAuthToken={setAuthToken} appUserName={appUserName} setAppUserName={setAppUserName}/>
    </AUTH_TOKEN.Provider>
  );
}




export default App;
